import { LocaleEnum } from '@systemeio/ui'
import { ContactField, Email } from '../../shared/ui'
import { request } from '../utils/request'

interface FieldsEmailResponse {
  contactFields?: ContactField[]
  exitUrl: string
  user?: {
    locale: LocaleEnum
    email: string
    id: number
  }
}

export interface FetchEmailTemplateResponse extends FieldsEmailResponse {
  email: Email
  mailing?: never
}

export interface FetchEmailResponse extends FieldsEmailResponse {
  mailing: {
    id: number
    currentEmail: Email
  }
  email?: never
}

export function fetchEmail(id: number, isTemplate: boolean) {
  return isTemplate
    ? request.get<FetchEmailTemplateResponse>(`/email/template/${id}/data`)
    : request.get<FetchEmailResponse>(`/mailing/${id}/data`)
}

export function save(email: Email, isTemplate: boolean) {
  return request.post<Email>(
    isTemplate ? `/email/template/${email.id}/save` : `/mailing/${email.id}/save`,
    {
      editor_api_email_content: {
        content: JSON.stringify(email.content),
        files: email.files.map(file => file.id),
      },
    },
  )
}
